module.exports = __webpack_public_path__ + "static/img/eventBackImg.deaeb90.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/eventBackImg.png
// module id = mG0n
// module chunks = 1